import {
  Card,
  Button,
  Input,
  Timeline
} from "antd";
import React, { useState, useEffect } from "react";
import {useParams, useNavigate } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import moment from "moment";
const Search = Input.Search;
function Activity() {
  const { request } = useRequest()
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const params = useParams()
  const navigate = useNavigate();
  useEffect(() => {
    setLoading(true)
    fetchData(params.id)
  }, [])
  const fetchData = (id) => {
    request({
      url: `/admin/downtown/get-activity-list/${id}`,
      method: 'get',
      onSuccess: (data) => {
        console.log(data.data)
        setLoading(false)
        setList(data.data.data)

      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR)
      }
    })
  }


  return (

    <Main>
      <Button type="primary" onClick={() => navigate(-1)} style={{ marginBottom: '16px' }}>
        Back
      </Button>
      <Card title="Activity Timeline">
        <Timeline>
          {list.length > 0 && list.map((item) => (
            <Timeline.Item color="green">
              <h5>{item.title}</h5>
              <p>{item.module ? item.module : item.action ? item.action : ''}</p>
              <span>{moment(item.created_at).format("YYYY-DD-MM HH:mm")}</span>
            </Timeline.Item>
          ))}


        </Timeline>
      </Card>
    </Main>




  );
}


export default Activity;
